// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3sOID","signatureButtonsRight":"ModalSign_signatureButtonsRight__3k0oP"};